/** Development Express — shared tokens (from Login / ClientDashboard) */
export const DE = {
  bg: "#050d1a",
  panel: "linear-gradient(135deg, #0f2040 0%, #0a1628 100%)",
  panelFlat: "linear-gradient(135deg, #0f2040, #0a1628)",
  gold: "#c9a84c",
  goldDim: "rgba(201,168,76,0.6)",
  muted: "#8896a8",
  text: "#e8e0d0",
  white: "#fff",
  navy: "#0a1628",
  logoGrad: "linear-gradient(135deg, #a07830, #e2c97e)",
  btnGrad: "linear-gradient(135deg, #a07830 0%, #e2c97e 50%, #a07830 100%)",
  border: "rgba(201,168,76,0.2)",
  borderStrong: "rgba(201,168,76,0.3)",
  green: "#4CAF50",
  red: "#e94560",
  gridBg:
    "linear-gradient(rgba(201,168,76,0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(201,168,76,0.03) 1px, transparent 1px)",
};

export const dePageBg = {
  minHeight: "100vh",
  background: DE.bg,
  fontFamily: "Arial, sans-serif",
  color: DE.white,
  position: "relative",
  overflow: "hidden",
};

export const deGrid = {
  position: "fixed",
  inset: 0,
  backgroundImage: DE.gridBg,
  backgroundSize: "50px 50px",
  pointerEvents: "none",
};

export const deGlow1 = {
  position: "fixed",
  top: "-20%",
  right: "-10%",
  width: "600px",
  height: "600px",
  background: "radial-gradient(circle, rgba(201,168,76,0.08) 0%, transparent 70%)",
  pointerEvents: "none",
};
